export default [
  {
    path: '',
    title : '',
    free: true
  },
  {
    path: 'antifranchise',
    title : "АнтиФраншиза",
    card: true,
    free: true
  },
  {
    path: 'consultation',
    title : "Консультация",
    free: true
  },
  {
    path: 'check',
    title : "Проверка beauty-бизнеса перед покупкой",
    card: true,
    free: true
  },
  {
    path: 'channel/:alias',
    title : "Канал",
    free: true,
    props: true
  },
  {
    path: 'publication/:id/:top?',
    title : "Статья",
    free: true,
    props: true
  },
  {
    path: 'politics',
    title : "Политика конфиденциальности",
    free: true
  },
  {
    path: 'offer',
    title : "Публичная оферта",
    free: true
  },
  {
    path: 'balance',
    title : "Колесо жизненного баланса",
    free: true,
    card: true
  },
  {
    path: 'balance/koleso',
    title : "Колесо жизненного баланса",
    free: true
  },
  {
    path: 'reviews',
    title : "Отзывы партнёров",
    free: true
  },
]